import React from "react";

const fileIcon = (name = "") => {
  const ext = name.split(".").pop().toLowerCase();
  if (ext === "pdf") return "/pdff.svg";
  if (ext === "xlsx" || ext === "xls") return "/Xls.svg";
  if (ext === "docx" || ext === "doc") return "/docX.svg";
  if (ext === "csv") return "/CSV.svg";
  if (ext === "txt") return "/TXT.svg";
  return "/pdf.svg";
};

const listNames = (names) =>
  names.length > 1 ? `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}` : names[0];

// Files that are already in the Knowledge Base are never uploaded again; this only tells the user where they are.
const DuplicateUploadModal = ({ items, otherCount = 0, onClose }) => {
  const many = items.length > 1;
  return (
    <div className="fixed inset-0 z-[9999] bg-[rgba(24,16,28,0.45)] flex items-center justify-center">
      <div className="w-[520px] max-w-[92vw] bg-white rounded-xl p-6 shadow-[0_24px_48px_rgba(24,16,28,0.3)] flex flex-col gap-4 font-outfit">
        <div className="flex flex-col gap-[6px]">
          <p className="m-0 text-[18px] font-semibold text-[#18181B]">
            {many ? "These files are already in your Knowledge Base" : "This file is already in your Knowledge Base"}
          </p>
          <p className="m-0 text-[14px] leading-[1.5] text-[#3F3F46]">
            {many ? "They won't be uploaded again." : "It won't be uploaded again."} To put a document in a
            different folder, use Move to Folder on the one that's already there.
          </p>
        </div>

        <div className="flex flex-col gap-2 max-h-[320px] overflow-y-auto custom-scrollbar">
          {items.map(({ file, match }, i) => {
            const folders = (match.all_folders || match.folders || []).map((f) => f.name);
            const copies = match.copies || 1;
            const sameName = (match.name || "").toLowerCase() === (file.name || "").toLowerCase();
            return (
              <div key={`${file.name}-${i}`} className="flex gap-3 p-3 border border-[#D4D4D8] rounded-lg bg-[#FAFAFA]">
                <img src={fileIcon(file.name)} alt="" className="w-7 h-7 flex-shrink-0" />
                <div className="flex-1 min-w-0 flex flex-col gap-1">
                  <span title={file.name} className="text-[14px] font-semibold text-[#18181B] truncate">
                    {file.name}
                  </span>
                  {!sameName && (
                    <span className="text-[13px] text-[#27272A] break-words">
                      Same content as <b className="font-semibold">{match.name}</b>
                    </span>
                  )}
                  <span className="text-[13px] text-[#27272A] break-words">
                    {folders.length ? `In ${listNames(folders)}` : "Not in any folder"}
                    {copies > 1 ? ` (${copies} copies)` : ""}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        {otherCount > 0 && (
          <p className="m-0 text-[13px] text-[#3F3F46]">
            {otherCount === 1 ? "The other file is" : `The other ${otherCount} files are`} being uploaded.
          </p>
        )}

        <div className="flex justify-end">
          <button
            type="button"
            autoFocus
            onClick={onClose}
            className="px-5 py-2 border border-[#A04A97] rounded-md bg-[#A04A97] hover:bg-[#8E3F86] text-white text-[14px] font-medium"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateUploadModal;
